import { useState } from 'react'
import useHttp from '@/shared/hooks/useHttp'

const useCsvExport = () => {
  const { sendRequest, getConfig } = useHttp()
  const [exporting, setExporting] = useState(false)
  const [exportError, setExportError] = useState(null)

  const exportCSV = (url, filename = 'agent_feedbacks.csv') => {
    setExportError(null)
    setExporting(true)
    const config = getConfig('GET', {
      'Accept': 'text/csv,application/json',
    })
    sendRequest(
      url,
      config,
      (data, _status, response) => {
        const contentType = response.headers.get('content-type') || ''
        if (contentType.includes('text/csv')) {
          const downloadUrl = window.URL.createObjectURL(data)
          const a = document.createElement('a')
          a.href = downloadUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          a.remove()
          window.URL.revokeObjectURL(downloadUrl)
        } else if (contentType.includes('application/json')) {
          setExportError(data.message || 'Unknown export feedback error.')
        } else {
          setExportError('Unknown export feedback error.')
        }
        setExporting(false)
      },
      'blob'
    )
  }

  return { exporting, exportError, setExportError, exportCSV }
}

export default useCsvExport
